var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 0.199951C4.70119 0.199951 0.400391 4.19355 0.400391 9.11424C0.400391 14.0349 4.70119 18.0285 10.0004 18.0285C15.2996 18.0285 19.6004 14.0349 19.6004 9.11424C19.6004 4.19355 15.2996 0.199951 10.0004 0.199951ZM9.04039 4.65709V6.43995H10.9604V4.65709H9.04039ZM9.04039 8.22281V13.5714H10.9604V8.22281H9.04039ZM2.32039 9.11424C2.32039 13.0454 5.76679 16.2457 10.0004 16.2457C14.234 16.2457 17.6804 13.0454 17.6804 9.11424C17.6804 5.18304 14.234 1.98281 10.0004 1.98281C5.76679 1.98281 2.32039 5.18304 2.32039 9.11424Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.763e6adc67f754b28fabb2ab6d47d89f.svg";
export { ForwardRef as ReactComponent };